module.exports = __webpack_public_path__ + "static/media/close-icon.efeaa595.svg";